<template>
  <div class="create u-overlay u-row u-center u-middle u-overflow-y-scroll u-pad-y-md">
    <app-form-login class="u-relative" :isNew="true" />
    <div v-show="!$device.isTablet" @click="$router.push($local('signin'))" class="t-link change-page t-text t-text--small u-grey-light">
      {{$t('login.alreadySign')}}
    </div>
  </div>
</template>

<script>
import AppFormLogin from '@/components/common/AppFormLogin'

export default {
  components: {
      AppFormLogin
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/settings/variables'

.create
  &:before
    position fixed
    
.change-page
  position absolute
  top $spacings.md
  right $spacings.md

</style>
